import { render, staticRenderFns } from "./ConfiguredCarousel.vue?vue&type=template&id=57a6cc23&scoped=true&"
import script from "./ConfiguredCarousel.vue?vue&type=script&lang=js&"
export * from "./ConfiguredCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguredCarousel.vue?vue&type=style&index=0&id=57a6cc23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a6cc23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VContainer,VLayout})
